<!-- NAVBAR -->
<nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top p-0 vs-top-navigation">
  <div class="container-fluid px-4">

    <!-- LOGO (LEFT) -->
    <a routerLink="/" class="navbar-brand d-flex align-items-center logo-a">
      <img src="images/logo.png" alt="Logo" class="top-logo">
    </a>

    <!-- MOBILE TOGGLE -->
    <button class="navbar-toggler d-lg-none button-menu" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu">
      <span class="navbar-toggler-icon"></span>
    </button>
    

    <!-- DESKTOP MENU -->
    <div class="collapse navbar-collapse justify-content-center d-none d-lg-flex">

      <div class="main-top-nav text-center">
 <!-- BOTTOM MENU -->
        <div class="navbar-nav sec_nav justify-content-center mt-2">
          @for(menu of olympiadMenu(); track menu.ProjectID){
          <div class="nav-item dropdown">
            <a class="nav-link cursor-pointer" [ngClass]="!menu.ActiveStatus ? 'dropdown-toggle':null " [class.active]="menu.ActiveStatus" data-bs-toggle="dropdown" >
               {{menu.ProjectName}}
            </a>@if(!menu.ActiveStatus){
              <div class="dropdown-menu">
                <a [routerLink]="['contest', menu.ProjectSlugName, 'about']" class="dropdown-item">{{ 'About' | translate }}</a>
                <a [routerLink]="['contest', menu.ProjectSlugName, 'brochure']" class="dropdown-item">{{ 'Brochure' | translate }}</a>
                <a [routerLink]="['gallery']" class="dropdown-item">{{ 'Gallery' | translate }}</a>
                <a [routerLink]="['contest', menu.ProjectSlugName, 'sample-papers']" class="dropdown-item">{{ 'Sample Papers' | translate }}</a>
                <a [routerLink]="['contest', menu.ProjectSlugName, 'syllabus']" class="dropdown-item">{{ 'Syllabus' | translate }}</a>
                <!-- <a [routerLink]="['contest', menu.ProjectSlugName, 'examination']" class="dropdown-item">{{ 'Examination' | translate }}</a> -->
                <a [routerLink]="['contest', menu.ProjectSlugName, 'winner-list']" class="dropdown-item">{{ 'Winner List' | translate }}</a>
              </div>    
            }                  
          </div>
          }     
        </div>
        <!-- TOP MENU -->
        <div class="navbar-nav first_nav justify-content-center">

          <a routerLink="/home" routerLinkActive="active" class="nav-link">{{ 'Home' | translate }}</a>
          <a routerLink="/about-us" routerLinkActive="active" class="nav-link">{{ 'About Us' | translate }}</a>  
          @if(!isLoggedIn()){
            <!-- <a routerLink="/registration" routerLinkActive="active" class="nav-link">{{ 'Registration' | translate }}</a> -->
          }  
          <a routerLink="/programme" routerLinkActive="active" class="nav-link">{{ 'Programme' | translate }}</a>
          <!-- <a [routerLink]="['contest', '2025', 'examination']" routerLinkActive="active" class="nav-link">{{ 'Examination' | translate }}</a> -->
          <!-- <a [routerLink]="['contest', '2025', 'winner-list']" routerLinkActive="active" class="nav-link">{{ 'Winner List' | translate }}</a> -->
          <!-- <a routerLink="/awards" routerLinkActive="active" class="nav-link">{{ 'Awards' | translate }}</a> -->
          <a routerLink="/gallery" routerLinkActive="active" class="nav-link">{{ 'Gallery' | translate }}</a>
          <a routerLink="/news" routerLinkActive="active" class="nav-link">{{ 'News' | translate }}</a>
          <a routerLink="/contact-us" routerLinkActive="active" class="nav-link">{{ 'Contact Us' | translate }}</a>
          
          @if(!isLoggedIn()){
            <a routerLink="/login" routerLinkActive="active" class="nav-link">{{ 'Login' | translate }}</a>
          }
          @if(isLoggedIn()){
            <a routerLink="/{{entityTypePrefix}}/dashboard" routerLinkActive="active" class="nav-link">{{ 'Dashboard' | translate }}</a>
          }

        </div>

       
      </div>
    </div>

    <!-- LANGUAGE SWITCH (RIGHT) -->

    <div class="header-right">
      <div class="logout">        
        
        <div class="profile-container" [ngClass]="{ 'active': isLoggedIn()}">
          @let userProfileInfo = userProfile();          
          @let entityTypePrefix = EntityTypes[userProfileInfo.EntityTypeID] || 'um';
          @if(isLoggedIn()){
            <img src="{{userProfileInfo.UploadPhoto ||'images/default_profile.png'}}" alt="{{userProfileInfo.FullName || 'NA'}}" class="avatar" id="profileBtn">
          }@else{
            <a routerLink="/"><img src="images/default_profile.png" class="avatar" alt="User Info" id="profileBtn"></a>
          }
          

          <div class="dropdown">
            <div class="user-info">              
              @if(isLoggedIn()){
                <img src="{{userProfileInfo.UploadPhoto ||'images/default_profile.png'}}" alt="{{userProfileInfo.FullName || 'NA'}}">
              }@else{
                <img src="images/default_profile.png" alt="User Info">
              }
              <div>
                <strong>{{userProfileInfo.FullName || 'NA'}}</strong>
                <span>{{userProfileInfo.RegistrationNo || 'NA'}}</span>
              </div>
            </div>
            <a routerLink="/{{entityTypePrefix}}" class="menu-item" data-tooltip="Dashboard">
              ⚙️ {{'Dashboard'|translate}} 
            </a>
            <a routerLink="/{{entityTypePrefix}}/profile" class="menu-item" data-tooltip="My profile">
              👤 {{'My profile'|translate}}
            </a>            
            <a routerLink="/{{entityTypePrefix}}" class="menu-item" data-tooltip="Support">
              🛟 {{'Support'|translate}}
            </a>
            <a (click)="logout()" class="menu-item logout" data-tooltip="Sign out">
              🚪 {{'Logout'|translate}}
            </a>
          </div>
        </div>

      </div>

      <div class="language d-lg-flex align-items-center">
        <a (click)="onChangeLanguage('EN')" [class.active]="userSelectedLanguage()==='EN'">
          English 
        </a>
        <span class="divider"></span>
        <a (click)="onChangeLanguage('HI')" [class.active]="userSelectedLanguage()==='HI'">
          हिन्दी
        </a>
      </div>
    </div>

  </div>
</nav>


<!-- MOBILE OFFCANVAS -->
<div class="offcanvas mobile-offcanvas offcanvas-start" tabindex="-1" id="mobileMenu">
  <div class="offcanvas-header">
    <div class="mob-header">
      <ul class="top-ul">           
         @if(isLoggedIn()){
      <li class="profile-section">
          <div class="avatar">
            <img src="https://testapi.vishwarang.com:443/AppDocumentFolder/default_profile.png" alt="madhav">
          </div>
          <div class="avatar-detail">
            <div>
              <h4>{{userProfileInfo.FullName}}</h4>
              <p>{{userProfileInfo.RegistrationNo}}</p>
            </div>
          </div>
      </li>
    }
    </ul>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    
  </div>
  <div class="offcanvas-body">
     @if(!isLoggedIn()){
     <a routerLink="/" class="logo-mobile">
      <img src="images/logo.png" alt="Logo" class="top-logo">
    </a>
     }
    <ul class="offcanvas-sidebar list-unstyled ps-0">
       
      
        @if(isLoggedIn() && userProfileInfo.EntityTypeID == 6){
          @for (menu of studentMenus; track menu.title) {
                <li class="first">
                    @if (!menu.children?.length) {
                    <button
                        [routerLink]="menu.route"
                        [ngClass]="{'active': groupUrl === menu.route}"
                        data-bs-dismiss="offcanvas" 
                        class="btn d-flex justify-content-between rounded w-100 ">
                        <span>
                            <i [class]="menu.icon"></i>
                            {{ menu.title | translate }}
                        </span>

                    </button>

                    } @else {

                    <button
                        class="btn btn-toggle d-flex justify-content-between rounded w-100"
                        data-bs-toggle="collapse"
                        [attr.data-bs-target]="'#' + menu.collapseId"
                        [attr.aria-expanded]="groupName === menu.groupName">

                        <span>
                            <i [class]="menu.icon"></i>
                            {{ menu.title | translate }}
                        </span>

                        <i class="bi bi-chevron-right"></i>
                    </button>

                    <div
                        class="collapse"
                        data-bs-dismiss="offcanvas" 
                        [id]="menu.collapseId"
                        [ngClass]="{'show': groupName === menu.groupName}">

                        <ul class="inner-icon btn-toggle-nav inner-ul list-unstyled fw-normal">

                            @for (child of menu.children; track child.title) {

                            <li>
                                <a
                                    [routerLink]="child.route"
                                    [ngClass]="{'active': groupUrl === child.route}"
                                    class="rounded">

                                    <i [class]="child.icon"></i>
                                    {{ child.title | translate }}
                                </a>
                            </li>

                            }

                        </ul>

                    </div>

                    }

                </li>

        }
        }
        @if(isLoggedIn() && userProfileInfo.EntityTypeID == 3){
          @for (menu of instituteMenus; track menu.title) {
                <li class="first">

                    @if (!menu.children?.length) {

                    <button data-bs-dismiss="offcanvas"
                        data-bs-dismiss="offcanvas" 
                        [routerLink]="menu.route"
                        [ngClass]="{'active': groupUrl === menu.route}"
                        class="btn d-flex justify-content-between rounded w-100">

                        <span>
                            <i [class]="menu.icon"></i>
                            {{ menu.title | translate }}
                        </span>

                    </button>

                    } @else {

                    <button
                        class="btn btn-toggle d-flex justify-content-between rounded w-100"
                        data-bs-toggle="collapse" 
                        [attr.data-bs-target]="'#' + menu.collapseId"
                        [attr.aria-expanded]="groupName === menu.groupName">

                        <span>
                            <i [class]="menu.icon"></i>
                            {{ menu.title | translate }}
                        </span>

                        <i class="bi bi-chevron-right"></i>
                    </button>

                    <div
                        class="collapse"
                        data-bs-dismiss="offcanvas" 
                        [id]="menu.collapseId"
                        [ngClass]="{'show': groupName === menu.groupName}">

                        <ul class="inner-icon btn-toggle-nav inner-ul list-unstyled fw-normal">

                            @for (child of menu.children; track child.title) {

                            <li>
                                <a data-bs-dismiss="offcanvas"
                                    [routerLink]="child.route"
                                    [ngClass]="{'active': groupUrl === child.route}"
                                    class="rounded">

                                    <i [class]="child.icon"></i>
                                    {{ child.title | translate }}
                                </a>
                            </li>

                            }

                        </ul>

                    </div>

                    }

                </li>

        }
        }
        

        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100" data-bs-dismiss="offcanvas" routerLink="/home">
            <span><i class="bi bi-house-door"></i>{{ 'Home' | translate }}</span>
          </button>
        </li>

        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100" data-bs-dismiss="offcanvas" routerLink="/about-us">
            <span><i class="bi bi-bookmark"></i>{{ 'About' | translate }}</span>
          </button>
        </li>
        <!-- @if(!isLoggedIn()){
        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/programme">
            <span><i class="bi bi-card-text"></i>{{ 'Registration' | translate }}</span>
          </button>
        </li>
      } -->
        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/programme">
            <span><i class="bi bi-card-text"></i>{{ 'Programme' | translate }}</span>
          </button>
        </li>
         <!-- <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/winner-list">
            <span><i class="bi bi-postcard"></i>{{ 'Winner list' | translate }}</span>
          </button>
        </li> -->
        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/gallery">
            <span><i class="bi bi-card-text"></i>{{ 'Gallery' | translate }}</span>
          </button>
        </li>
        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/news">
            <span><i class="bi bi-card-text"></i>{{ 'News' | translate }}</span>
          </button>
        </li>

        <!-- <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/programme">
            <span><i class="bi bi-person-workspace"></i>{{ 'Examination' | translate }}</span>
          </button>
        </li> -->

       

        <li class="first">
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100"data-bs-dismiss="offcanvas" routerLink="/contact-us">
            <span><i class="bi bi-headset"></i>{{ 'Contact Us' | translate }}</span>
          </button>
        </li>
        <li class="first">
         @if(!isLoggedIn()){
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100" data-bs-dismiss="offcanvas" routerLink="/login">
            <span><i class="bi bi-person-bounding-box"></i>{{ 'Login' | translate }}</span>
          </button>
        }@else{
          <button class="btn btn-toggle d-flex justify-content-between rounded w-100" data-bs-dismiss="offcanvas" (click)="logout()">
            <span><i class="bi bi-box-arrow-left"></i>{{ 'Logout' | translate }}</span>
          </button>
        }
        </li>


        @for(menu of olympiadMenu(); track menu.ProjectID){
          <li class="first">
              <button [routerLink]="menu.ActiveStatus ? ['programme'] :null" class="btn btn-toggle d-flex justify-content-between rounded w-100" data-bs-toggle="collapse" attr.data-bs-target="#Olympiad{{menu.ProjectID}}" aria-expanded="false" data-bs-dismiss="offcanvas">
                <span><i class="bi bi-globe-americas"></i> {{menu.ProjectName}}</span><i class="bi bi-chevron-right"></i>
              </button>
              @if(!menu.ActiveStatus){
              <div class="collapse" id="Olympiad{{menu.ProjectID}}">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li><a [routerLink]="['contest', menu.ProjectSlugName, 'about']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'About' | translate }}</a></li>
                  <li><a [routerLink]="['contest', menu.ProjectSlugName, 'brochure']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Brochure' | translate }}</a></li>
                  <li><a [routerLink]="['gallery']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Gallery' | translate }}</a></li>
                  <li><a [routerLink]="['contest', menu.ProjectSlugName, 'sample-papers']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Sample Papers' | translate }}</a></li>
                  <li><a [routerLink]="['contest', menu.ProjectSlugName, 'syllabus']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Syllabus' | translate }}</a></li>
                  <!-- <li><a [routerLink]="['contest', menu.ProjectSlugName, 'examination']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Examination' | translate }}</a></li> -->
                  <li><a [routerLink]="['contest', menu.ProjectSlugName, 'winner-list']" class="link-dark rounded" data-bs-dismiss="offcanvas" ><i class="bi bi-arrow-right-short"></i>{{ 'Winner List' | translate }}</a></li>
                </ul>
              </div>
              }
          </li>
        }

    </ul>
  </div>  
</div>